import { render, staticRenderFns } from "./CollectionSummary.vue?vue&type=template&id=13a71c88&scoped=true"
import script from "./CollectionSummary.vue?vue&type=script&lang=js"
export * from "./CollectionSummary.vue?vue&type=script&lang=js"
import style0 from "./CollectionSummary.vue?vue&type=style&index=0&id=13a71c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a71c88",
  null
  
)

export default component.exports